export default __webpack_public_path__ + "img/c6e9bf9a0987d6c908d5e5ea4044b3fa.svg";